import GoogleTagManagerNewSignIn from '@reaffiliates/GoogleTagManager/GoogleTagManagerNewSignIn';
const ReaffiliatesNewSignIn = (userID: string) => {
  GoogleTagManagerNewSignIn(userID);
};
export default ReaffiliatesNewSignIn;